import React, { useCallback, useEffect, useState } from "react";
import { TabOne } from "./Tab1Components/TabOne";
import { TabTwo } from "./Tab1Components/TabTwo";
import { TabThree } from "./Tab1Components/TabThree";
import { TabFour } from "./Tab1Components/TabFour";
import { fetchClientData } from "../../../redux/client/clientSlice";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { debounce } from "lodash";
import socket from "../../../context/socket";
import axios from "axios";
import Swal from "sweetalert2"; // Import Swal
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../utils/api";
import moment from "moment";
import { Alert } from "react-bootstrap";
import CustomLoader from "../../CustomLoader";

export const Tab1 = ({ setSelectedCards, selectedCards, setSelectedTab, selectedTab, setPrsuggections, isPrsuggections,
  selectedMember, setSelectedMember, isChecked, setIsChecked

}) => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false)

  const goalEventId = searchParams.get("goalEventId");
  const prId = searchParams.get("prId");
  const prDate = searchParams.get("prDate");

  const [hasHouseHold, setHasHouseHold] = useState(false);
  const [hsData, setHsData] = useState({});
  // useEffect(() => {

  //   if (goalEventId) {
  //     setActiveTab("profile-tab");
  //   } else if (prId) {
  //     setActiveTab("home-tab");
  //   }
  // }, [searchParams]);

  const navigate = useNavigate();
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  // const { id } = useParams();
  const dispatch = useDispatch();
  const [isPortfolioData, setIsPortfolioData] = useState({});
  const [isPortfolioDataNEW, setIsPortfolioDataNEW] = useState({});


  // console.log("isPrsuggections", isPrsuggections,isPortfolioData)

  const { clientData, } = useSelector((state) => state.client);



  // Fetch client data using Redux
  useEffect(() => {
    const clientId = roomId;
    dispatch(fetchClientData(clientId));
  }, []);


  // Step 1: Get household members
  useEffect(() => {

    if (
      selectedMember &&
      typeof selectedMember.pan === "string" &&
      typeof selectedMember.client_name === "string"
    ) {
      // console.log("Skipping getInvestor – member already selected", selectedMember);
      setHasHouseHold(true);

      return; // ✅ Do not call getInvestor
    }

    const getInvestor = async () => {
      try {
        const response = await api.get(
          `advisor/gethouseHoldPanInfo/${roomId}`
        );
        const bankDetails = response.data;
        console.log("selectedMember", selectedMember, bankDetails);

        console.log('bankDetails', bankDetails)
        if (bankDetails.length > 0) {

          setHsData(bankDetails[0])
          setHasHouseHold(true);
          if (bankDetails.length === 1) {
            setSelectedMember(bankDetails[0]);
          } else {
            setSelectedMember({ pan: "all", client_name: "Household", groupId: bankDetails[0]?.groupId || null });
          }
        } else {
          setHasHouseHold(false);
        }
      } catch (error) {
        console.error("Error fetching household PAN info:", error);
        setSelectedMember({ pan: "all", client_name: "Household" });
      }
    };

    getInvestor();
  }, []);

  // Step 2: Fetch portfolio data after member is selected
  useEffect(() => {


    if (
      selectedMember &&
      typeof selectedMember.pan === "string" &&
      typeof selectedMember.client_name === "string"
    ) {
      fetchPortfolioData();
    }

  }, [selectedMember, hasHouseHold]);

  const fetchPortfolioData = async () => {
    setLoading(true)
    try {
      // Show loading modal before API call
      // Swal.fire({
      //   // title: 'Loading Portfolio Data',
      //   text: "Please wait...",
      //   imageUrl: 'https://www.finedge.in/assets/images/download.gif',
      //   showConfirmButton: false,
      //   allowOutsideClick: false,
      //   allowEscapeKey: false,
      // });



      const formattedPrDate = moment(prDate);
      const isHousehold = selectedMember?.pan === "all";
      const cutoffDate = moment("2025-09-25", "YYYY-MM-DD");      // static date jis se compare karna hai

      let allData = {}
      console.log('allDataA', allData, selectedMember);

      let endpoint = "";
      if (formattedPrDate.isBefore(cutoffDate)) {
        allData = {
          portfolioId: prId,
          client_id: roomId
        }
        endpoint = "advisor/past_portfolio_review";
        const response = await api.post(endpoint, allData);
        // console.log(response.data);

        // Set Portfolio Data
        setIsPortfolioData(response.data);
      } else {

        allData = isHousehold
          ? { groupId: selectedMember.groupId, memberId: "", client_id: roomId, portfolioId: prId }
          : { groupId: selectedMember.groupId, memberId: selectedMember.wo_id, client_id: roomId, portfolioId: prId, }

        endpoint = "advisor/past_portfolio_review_wm";
        const response = await api.post(endpoint, allData);
        // console.log(response.data);

        // Set Portfolio Data
        setIsPortfolioDataNEW(response.data);
      }
    } catch (error) {
      navigate(`/?clientId=${roomId}`)

      console.error("Error fetching portfolio data:", error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Failed to load portfolio data. Please try again later.',
      });
    }
    finally {
      setTimeout(() => {

        setLoading(false)
      }, 500);
      Swal.close();
    }
  };


  // useEffect(() => {
  //   fetchPortfolioData();
  // }, [selectedMember]);





  if (loading) {
    return (
      <>
        <CustomLoader />
      </>
    )
  }
  if (!hasHouseHold) {
    return (
      <Alert
        variant="success"
        className="fw-bold d-block text-center mt-4"
      >
        Household data not avilable.
      </Alert>
    )
  }
  return (
    <div>
      <div className="row">
        <div className="col">
          {selectedTab === 1 && (
            <TabOne
              setSelectedCards={setSelectedCards}
              selectedCards={selectedCards}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              roomId={roomId}
              clientData={clientData}
              setPrsuggections={setPrsuggections}
              isPrsuggections={isPrsuggections}
              isPortfolioData={isPortfolioData}
              isPortfolioDataNEW={isPortfolioDataNEW}
            />
          )}
          {selectedTab === 2 && (
            <TabTwo
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              roomId={roomId}
              isPrsuggections={isPrsuggections}
              isPortfolioData={isPortfolioData}
              fetchPortfolioData={fetchPortfolioData}
              setPrsuggections={setPrsuggections}
              isPortfolioDataNEW={isPortfolioDataNEW}
            />
          )}
          {selectedTab === 3 && (
            <TabThree
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              roomId={roomId}
              isPortfolioData={isPortfolioData}
              setIsChecked={setIsChecked}
              isChecked={isChecked}
              isPortfolioDataNEW={isPortfolioDataNEW}
            />
          )}
          {selectedTab === 4 && (
            <TabFour
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              roomId={roomId}
              isPortfolioData={isPortfolioData}
              setSelectedMember={setSelectedMember}
              fetchPortfolioData={fetchPortfolioData}
              selectedMember={selectedMember}
              isPortfolioDataNEW={isPortfolioDataNEW}
            />
          )}
        </div>
      </div>
    </div>
  );
};
